import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Button } from 'antd'
import AntdTable from '../../../components/table/AntdTable'
import { formatMessageNew, paginationInit, downLoadFileBlob } from '../../../utils/common'
import { getNFCSKUHistoryList } from '../../../services/configuration/config'
import { getSKUHistoryExport } from '../../../services/SendList/SendList'
import { configQuery, getTagTypeList } from '../../../services/configuration/config'

const NfcSkuModalTable = props => {
  const language = useSelector(state => state.commonStore.language)
  const [pagination, setPagination] = useState(paginationInit)
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [filtersObj, setFiltersObj] = useState({
    channel: null,
    plantCode: null,
    tagType: null
  })
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.commonLocale.productCode'),
      width: 50,
      dataIndex: 'productCode',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.productName'),
      width: 100,
      dataIndex: 'productName',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: <div style={{ whiteSpace: 'nowrap' }}>{formatMessageNew('languageObj.configuration.channel')}</div>,
      width: '10%',
      dataIndex: 'channel',
      filters: [],
      // filteredValue: filtersObj.channel || null,
      filterSearch: true,
      filterMultiple: false,
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.configuration.plant'),
      width: '10%',
      dataIndex: 'plantCode',
      filters: [],
      // filteredValue: filtersObj.plantCode || null,
      filterSearch: true,
      filterMultiple: false,
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.configuration.tagType'),
      width: '25%',
      dataIndex: 'tagType',
      filters: [],
      // filteredValue: filtersObj.tagType || null,
      filterSearch: true,
      filterMultiple: false,
      render: (text, record) => {
        if (text) {
          let ls = text.split(',')
          let tagTypeDesc = record.tagTypeDesc.split(',')
          return ls.map((item, idx) => {
            return (
              <div key={idx} className="word_break_word">
                <span className="tagType">{item}</span>
                <span className="splitSpan">-</span>
                {tagTypeDesc[idx]}
                {idx < ls.length - 1 ? ',' : ''}
              </div>
            )
          })
        } else {
          return <div className="word_break_word">{text}</div>
        }
      }
    },
    {
      title: formatMessageNew('languageObj.configuration.lastUpdate'),
      width: 50,
      dataIndex: 'operator',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.configuration.createTime'),
      width: 50,
      dataIndex: 'createTime',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    }
  ]
  const [stateTableColumns, setStateTableColumns] = useState(tableColumns)
  useEffect(() => {
    setFiltersObj({
      channel: null,
      plantCode: null,
      tagType: null
    })
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    getDictionnaryHistoryDropListFun(props.productCode)
    setQueryFlag(!queryFlag)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.productCode])
  useEffect(() => {
    stateTableColumns.forEach(itemFirst => {
      switch (itemFirst.dataIndex) {
        case 'channel':
          itemFirst.filteredValue = filtersObj.channel || null
          break
        case 'plantCode':
          itemFirst.filteredValue = filtersObj.plantCode || null
          break
        case 'tagType':
          itemFirst.filteredValue = filtersObj.tagType || null
          break
        default:
          break
      }
    })
    setStateTableColumns([...stateTableColumns])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersObj])
  useEffect(() => {
    stateTableColumns.forEach((itemFirst, idx) => {
      itemFirst.title = tableColumns[idx].title
    })
    setStateTableColumns([...stateTableColumns])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  useEffect(() => {
    getTableList(props.productCode)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  const getDictionnaryHistoryDropListFun = code => {
    let num = 99999999
    const params1 = {
      configKey: 'plant_code',
      configStatus: true,
      configType: 'plant_code_config',
      pageNo: 1,
      size: num,
      total: num
    }

    const params2 = {
      configKey: 'channel',
      configStatus: true,
      configType: 'channel_config',
      pageNo: 1,
      size: num,
      total: num
    }

    const params3 = {
      description: '',
      configStatus: true,
      pageNo: 1,
      size: num,
      total: num
    }
    Promise.all([configQuery(params1), configQuery(params2), getTagTypeList(params3)]).then(res => {
      try {
        stateTableColumns.forEach(itemFirst => {
          if (
            itemFirst.dataIndex === 'channel' ||
            itemFirst.dataIndex === 'plantCode' ||
            itemFirst.dataIndex === 'tagType'
          ) {
            let arr = []
            switch (itemFirst.dataIndex) {
              case 'plantCode':
                let res0 = res[0].resultData.records
                arr.push({
                  text: 'ALL',
                  value: 'ALL'
                })
                for (let index = 0; index < res0.length; index++) {
                  const element = res0[index]
                  arr.push({
                    text: element.configValue,
                    value: element.configValue
                  })
                }
                break
              case 'channel':
                let res1 = res[1].resultData.records
                for (let index = 0; index < res1.length; index++) {
                  const element = res1[index]
                  arr.push({
                    text: element.configValue,
                    value: element.configValue
                  })
                }
                break
              case 'tagType':
                let res2 = res[2].resultData.records
                for (let index = 0; index < res2.length; index++) {
                  const element = res2[index]
                  arr.push({
                    text: element.type,
                    value: element.type
                  })
                }
                break
              default:
                break
            }
            itemFirst.filters = arr
          }
        })
        setStateTableColumns([...stateTableColumns])
      } catch (error) {}
    })
  }
  const getTableList = code => {
    const params = {
      productCode: code,
      size: pagination.pageSize,
      pageNo: pagination.currentPage,
      total: pagination.total,
      //表头筛选
      channel: filtersObj.channel?.length > 0 ? filtersObj.channel[0] : '',
      plant: filtersObj.plantCode?.length > 0 ? filtersObj.plantCode[0] : '',
      tagType: filtersObj.tagType?.length > 0 ? filtersObj.tagType[0] : ''
    }
    getNFCSKUHistoryList(params).then(res => {
      if (res.errorCode === '200') {
        const dt = res.resultData
        setTableList(dt.records)
        const pg = {
          ...pagination,
          total: dt.total
        }
        setPagination(pg)
      }
    })
  }

  const handleTableChange = (pagina, filters) => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setFiltersObj(filters)
    setQueryFlag(!queryFlag)
  }

  const downLoadFun = () => {
    const params = {
      productCode: props.productCode,
      isChinese: language === 'zh_CN' ? true : false,
      //表头筛选
      channel: filtersObj.channel?.length > 0 ? filtersObj.channel[0] : '',
      plant: filtersObj.plantCode?.length > 0 ? filtersObj.plantCode[0] : '',
      tagType: filtersObj.tagType?.length > 0 ? filtersObj.tagType[0] : ''
    }
    getSKUHistoryExport(params)
      .then(res => {
        downLoadFileBlob(res)
      })
      .catch(error => {})
  }

  return (
    <AntdTable
      title={() => {
        return (
          <>
            <div style={{ display: 'flex' }}>
              <Button type="primary" onClick={downLoadFun}>
                {formatMessageNew('languageObj.commonLocale.download')}
              </Button>
            </div>
          </>
        )
      }}
      dataSource={tableList}
      columns={stateTableColumns}
      pagination={pagination}
      onChange={handleTableChange}
    />
  )
}
export default NfcSkuModalTable
